import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.seeds_index_page', () => {
  import('./internal/seeds_index_page').then(({ default: Component }) => Component());
});
